<template>
  <div class="AddTestPaperModal">
    <!--    <CorrectPolyPhoneModal-->
    <!--        @refreshInputVal="refreshInputVal"-->
    <!--        :inputValArr="inputValArr"-->
    <!--    ></CorrectPolyPhoneModal>-->
    <el-dialog
        title="编辑试卷"
        :visible.sync="visible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
    >
      <el-form
          ref="form"
          :model="formData"
          :rules="rules"
          size="mini"
          label-width="90px">
        <el-form-item label="试卷名称:" prop="questionType">
          <el-input
              v-model="formData.name"
          ></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: center">
        <el-button type="primary" @click="handleSaveTestPaper">
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapActions, mapMutations} from "vuex";
import SearchKnowledge from "@/pages/MyOutLine/SearchKnowledge.vue";
import CorrectPolyPhoneModal from "@/pages/MyOutLine/CorrectPolyPhoneModal.vue";
import {QUESTION_TYPE, SUBJECT_TYPE} from "@/utils/constants";
import MultiContentComponent from "@/pages/MyOutLine/components/MultiContentComponent.vue";
import ContentPickModal from "@/pages/MyOutLine/components/ContentPickModal.vue";
import AudioText from "@/pages/MyOutLine/components/AudioText.vue";
import testPaperList from "@/pages/QuestionBank/TestPaperList.vue";

export default {
  name: "AddTestPaperModal",
  props: {},
  components: {AudioText, ContentPickModal, MultiContentComponent, SearchKnowledge, CorrectPolyPhoneModal},
  mixins: [],
  data() {
    return {
      formData: this.defaultFormData(),
      rules: {}
    };
  },
  watch: {},
  computed: {
    visible: {
      get() {
        return this.$store.state.pluginCenter.addTestPaperModalVisible;
      },
      set(value) {
        this.$store.commit("pluginCenter/setData", {
          key: "addTestPaperModalVisible",
          value,
        });
      },
    },
  },
  mounted() {
  },
  methods: {
    ...mapActions("pluginCenter", ["saveTestPaper", "getTestPaperList"]),
    async handleSaveTestPaper() {
      await this.saveTestPaper(this.formData);
      this.$message.success("试卷保存成功")
      this.visible = false;
      await this.getTestPaperList({});
    },
    initFormData(data) {
      if (data) {
        this.formData = {...data};
      } else {
        this.formData = this.defaultFormData();
      }
    },
    defaultFormData() {
      return {
        id: 0,
        name: ""
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.AddTestPaperModal {
  width: 100%;
}
</style>
